<div class="services-page" #servicesRoot>
  <app-services-hero-section></app-services-hero-section>
  <app-services-grid-section [services]="services"></app-services-grid-section>
  <app-services-process-section [processSteps]="processSteps"></app-services-process-section>
  <app-services-final-cta-section></app-services-final-cta-section>
</div>
